import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    OriginalBalanceByTags : [],
    loading : false,
    error : null,
};

const fetchOriginalBalanceByTagsSlice = createSlice({
    name:"OriginalBalanceByTags",
    initialState,
    reducers: {
        fetchOriginalBalanceByTagsSuccess: (state,action) => {
            state.loading = false;
            state.OriginalBalanceByTags = action.payload
        },
        fetchOriginalBalanceByTagsFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    }
})

export const {
    fetchOriginalBalanceByTagsFailure,
    fetchOriginalBalanceByTagsSuccess
} = fetchOriginalBalanceByTagsSlice.actions

export default fetchOriginalBalanceByTagsSlice.reducer